export default __webpack_public_path__ + "static/panaro-b39949351e8275f0d7b2c8772c8ea90a.jpg";